export const GET_PLACEMENTS = "Get placements";
export const ADD_PLACEMENT = "Add placement"
